<template>
  <v-app>
    <Header class="header">
      <slot name="header"></slot>
    </Header>
    <v-main>
      <v-progress-linear :active="isLoading" indeterminate absolute top color="deep-purple accent-4"></v-progress-linear>
      <slot />
    </v-main>
    <SnackBar />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "@/components/_layout/header";
import SnackBar from "@/components/_system/snackbar.vue";

export default {
  data: () => ({}),

  components: {
    Header,
    SnackBar,
  },

  created() {},

  beforeDestroy() {},

  computed: {
    ...mapGetters(["isAdmin", "isLoading", "isLoggedIn"]),
  },

  methods: {},
};
</script>

<style lang="scss">
.header {
  .v-chip {
    border-width: 3px;
  }
  .v-chip--active {
    font-weight: bold;
  }
}

@media print {
  .v-content {
    padding-left: 0 !important;
  }
}
</style>
